var R = /* @__PURE__ */ ((A) => (A[A.BACKSPACE = 8] = "BACKSPACE", A[A.DELETE = 46] = "DELETE", A[A.LEFT_ARROW = 37] = "LEFT_ARROW", A[A.NINE = 57] = "NINE", A[A.NUMPAD_0 = 96] = "NUMPAD_0", A[A.NUMPAD_9 = 105] = "NUMPAD_9", A[A.RIGHT_ARROW = 39] = "RIGHT_ARROW", A[A.TAB = 9] = "TAB", A[A.V = 86] = "V", A[A.ZERO = 48] = "ZERO", A))(R || {});
export {
  R as KEYCODE
};
